import React from 'react';
/**
 * ToolbarGroup Component
 * Wraps a set of buttons in a horizontal flex row.
 * Groups are separated by ToolbarDivider in the parent Toolbar.
 */
export function ToolbarGroup({ children, className = '', pinned = false, align = 'start' }) {
    // pinned / align are read by the parent Toolbar via props — no rendering effect here
    void pinned;
    void align;
    const combinedClass = ['qmb-ui-toolbar__group', className].filter(Boolean).join(' ');
    return React.createElement("div", { className: combinedClass }, children);
}
